module.exports = __webpack_public_path__ + "static/media/4_3.5bb076a4.jpg";